export const complaintTypes: Record<string, string> = { RETURN: 'Zwrot', COMPLAINT: 'Reklamacja', EXCHANGE: 'Wymiana' };
export const complaintStatuses: Record<string, string> = { SUBMITTED: 'Nowe', IN_REVIEW: 'W rozpatrywaniu', ACCEPTED: 'Zaakceptowane', REJECTED: 'Odrzucone', RESOLVED: 'Zakończone' };

export function formatComplaintHistory(entry: { action: string; description?: string; metadata?: Record<string, unknown> | null }) {
  const metadata = entry.metadata;
  if (entry.action === 'complaint_submitted') {
    const type = typeof metadata?.complaintType === 'string' ? complaintTypes[metadata.complaintType] : undefined;
    return { title: 'Złożono zgłoszenie', description: type || entry.description || 'Wniosek z panelu klienta', color: 'text-info', icon: '↩' };
  }
  if (entry.action === 'complaint_status_changed') {
    const oldStatus = typeof metadata?.oldStatus === 'string' ? complaintStatuses[metadata.oldStatus] : undefined;
    const legacyStatus = entry.description?.match(/(?:na:|na)\s*(SUBMITTED|IN_REVIEW|ACCEPTED|REJECTED|RESOLVED)\b/)?.[1];
    const newStatus = complaintStatuses[String(metadata?.newStatus || legacyStatus || '')];
    return { title: 'Zmiana statusu zgłoszenia', description: oldStatus && newStatus ? `${oldStatus} → ${newStatus}` : newStatus ? `Nowy status: ${newStatus}` : 'Zaktualizowano status zgłoszenia', color: 'text-accent-primary', icon: '↩' };
  }
  return null;
}
